var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"f_ocx2"}},[_c('iframe',{attrs:{"name":"myiframe","id":"ocx2","src":_vm.cdbm,"frameborder":"0","align":"middle","width":"100%","height":"100%","scrolling":"no","allow":"microphone; camera; display-capture;"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }